<template>
	<div class="position-relative" style="z-index: 1037">
    <div class="row no-gutters justify-content-center">
      <div class="fixed-bottom d-block nav-bottom" style="bottom:0;top: 0">
        <div class="custom-container-fluid px-0" style="box-shadow: 1px 0px 6px 2px #dfdfdf4f">
          <div class="row justify-content-center no-gutters">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
              <div :class="{'container px-4': type == 'guest' || type == 'promo' || type == 'merchant'}" class="py-3 bg-white box-shadow-main popup-scroll" style="height: 100vh">
                <div class="my-5 text-center" v-if="is_load">
                  <loader />
                </div>
                <template v-else>
                  <!-- MERCHANT -->
                  <template v-if="type == 'merchant'">
                    <div class="mb-2 pb-1">
                      <img src="../../../assets/img/icon/back-arrow.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" v-if="getBeFirstLoad()" @click="changeView('swipe','guest')">
                      <img src="../../../assets/img/icon/close.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" v-else @click="changeView('close','close')">
                    </div>
                    <div class="pb-2" v-if="$showCommunity()">
                      <p class="mb-0 body-2-2 text-22 font-bold d-inline-block">Property</p>
                      <p class="mb-0 body-2-2">Choose your destination</p>
                      <div class="mt-4">
                        <div class="rounded-4 bg-white border-semi-grey w-100">
                          <div class="p-3">
                            <div class="row no-gutters">
                              <div class="col-11">
                                <p class="mb-0 text-12 body-2 cursor-pointer font-regular">Property</p>
                                <div class="position-relative">
                                  <img src="../../../assets/img/icon/location.png" width="12" class="d-inline-block align-top mr-2 position-relative" style="top: 8px" />
                                  <p class="mb-0 body-2-2 font-bold cursor-pointer d-inline-block w-75 mt-1" v-if="merchant_selected.name">{{ merchant_selected.name }}</p>
                                </div>
                              </div>
                              <div class="col-1 align-self-center">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.12053 3.87295C2.26663 3.72392 2.49525 3.71037 2.65636 3.83231L2.70251 3.87295L6 7.23671L9.29749 3.87295C9.44359 3.72392 9.67221 3.71037 9.83331 3.83231L9.87947 3.87295C10.0256 4.02198 10.0388 4.25519 9.91931 4.41952L9.87947 4.4666L6.29099 8.12705C6.14489 8.27608 5.91627 8.28963 5.75517 8.1677L5.70901 8.12705L2.12053 4.4666C1.95982 4.30267 1.95982 4.03688 2.12053 3.87295Z" fill="#999999"/>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div 
                            class="w-100 p-3 ota-property-select-item"
                            v-for="merchant in merchant_list"
                            :class="{'active-item':merchant_selected.id && merchant.id == merchant_selected.id}"
                            @click="selectOtherMerchant(merchant)">
                            <p class="mb-0 body-2-1">{{ merchant.name }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <template>
                      <div class="position-relative" style="z-index: 1037;">
                        <div class="row no-gutters justify-content-center">
                          <div class="fixed-bottom d-block" style="bottom:0px">
                            <div class="custom-container-fluid px-0">
                              <div class="row justify-content-center no-gutters">
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                                  <div class="container bg-white px-4 py-2 box-shadow-top">
                                    <div class="row slim-grid-row">
                                      <div class="col-12">
                                        <button type="button" class="button-secondary w-100" @click="changeView('change-merchant',merchant_selected.id)"><img src="../../../assets/img/icon/search-white.png" class="mr-1 position-relative" style="top: -1px;" width="15">{{$t('hotel.search')}}</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                  <!-- DATE -->
                  <template v-else-if="type == 'date'">
                    <div class="container px-4 mb-2 pb-1">
                      <div class="row">
                        <div class="col-1 align-self-center">
                          <template v-if="getBeFirstLoad()">
                            <router-link :to="'/'+getMerchant().code">
                              <img src="../../../assets/img/icon/back-arrow.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15">
                            </router-link>
                          </template>
                          <template v-else>
                            <img src="../../../assets/img/icon/close.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" @click="changeView('close','close')">
                          </template>
                        </div>
                        <div class="col-11 align-self-center">
                          <p class="mb-0 body-2-4 mt-1">{{ getMerchant().name }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="scroll-hide-mobile popup-scroll-body pt-2 pb-4" style="height: 82vh;overflow-x: scroll;">
                      <div class="pb-0 container px-4 pb-3">
                        <p class="mb-0 body-2-2 text-22 font-bold">{{$t('hotel.date.check-in')}} - {{$t('hotel.date.check-out')}}</p>
                        <p class="mb-0 body-2-2 font-regular">{{$t('hotel.date.desc')}}</p>
                      </div>
                      <CalendarRoom 
                        :date_default="dateRange"
                        opens="inline"
                        :is_double="false"
                        @finish="applyDateFilter"
                        wrapper_class="calendar-be-active form-control w-100 border-none body-2-2 pt-3 pb-0 font-semibold d-table mb-5"></CalendarRoom>
                    </div>
                    <transition name="fade">
                      <div class="fixed-bottom d-block" style="bottom:0px;z-index: 1042;">
                        <div class="custom-container-fluid px-0">
                          <div class="row justify-content-center no-gutters">
                            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                              <div class="container bg-white px-4 py-2 box-shadow-top">
                                <div class="row slim-grid-row">
                                  <div class="col-4">
                                    <div class="border-black rounded-4 w-100 py-12px">
                                      <p class="mb-0 text-center body-2-2 font-bold text-dark" @click="dateReset()">{{$t('hotel.clear')}}</p>
                                    </div>
                                  </div>
                                  <div class="col-8">
                                    <button type="button" v-if="getBeFirstLoad()" class="button-primary w-100" @click="changeView('swipe','guest')">{{$t('hotel.next')}}</button>
                                    <button type="button" v-else class="button-secondary w-100" @click="changeView('close','done')"><img src="../../../assets/img/icon/search-white.png" class="mr-1 position-relative" style="top: -1px;" width="15">{{$t('hotel.search')}}</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </template>
                  <!-- GUEST -->
                  <template v-else-if="type == 'guest'">
                    <div class="mb-2 pb-1">
                      <div class="row">
                        <div class="col-1 align-self-center">
                          <img src="../../../assets/img/icon/back-arrow.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" v-if="getBeFirstLoad()" @click="changeView('swipe','date')">
                          <img src="../../../assets/img/icon/close.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" v-else @click="changeView('close','close')">
                        </div>
                        <div class="col-11 align-self-center">
                          <p class="mb-0 body-2-4 mt-1">{{ getMerchant().name }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="pb-2">
                      <p class="mb-0 body-2-2 text-22 font-bold d-inline-block">{{$t('hotel.guests.guests')}}</p>
                      <p class="mb-0 body-2-2 font-regular">{{$t('hotel.guests.desc')}}</p>
                    </div>
                    <div class="">
                      <template v-for="(guest,index) in guests">
                        <div class="row py-3 no-gutters border-bottom" v-if="guest.show">
                          <div class="col-8">
                            <p class="mb-0 body-2-2 font-bold text-18">{{guest.name}}</p>
                            <p class="mb-0 body-2-2 font-regular">{{guest.desc}}</p>
                          </div>
                          <div class="col-4 text-center mt-1">
                            <div class="row py-1 text-right w-100 no-gutters">
                              <div class="col-4 text-center">
                                <img src="../../../assets/img/icon/minus-black.png" class="cursor-pointer border rounded-100 p-2" width="31" @click="changeQty('dec',index)">
                              </div>
                              <div class="col-4 text-center">
                                <p class="mb-0 body-2-2 font-bold text-16 position-relative" style="top: 3px;">{{guest.qty}}</p>
                              </div>
                              <div class="col-4 text-center">
                                <img src="../../../assets/img/icon/plus-black.png" class="cursor-pointer border rounded-100 p-2" width="31" @click="changeQty('inc',index)">
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <transition name="fade">
                      <template>
                        <div class="position-relative" style="z-index: 1037;">
                          <div class="row no-gutters justify-content-center">
                            <div class="fixed-bottom d-block" style="bottom:0px">
                              <div class="custom-container-fluid px-0">
                                <div class="row justify-content-center no-gutters">
                                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                                    <div class="container bg-white px-4 py-2 box-shadow-top">
                                      <div class="row slim-grid-row">
                                        <div class="col-4">
                                          <div class="border-black rounded-4 w-100 py-12px">
                                            <p class="mb-0 text-center body-2-2 font-bold text-dark" @click="changeQty('clear')">{{$t('hotel.clear')}}</p>
                                          </div>
                                        </div>
                                        <div class="col-8">
                                          <button type="button" v-if="getBeFirstLoad()" class="button-primary w-100" @click="changeView('swipe','promo')">{{$t('hotel.next')}}</button>
                                          <button type="button" v-else class="button-secondary w-100" @click="changeView('close','done')"><img src="../../../assets/img/icon/search-white.png" class="mr-1 position-relative" style="top: -1px;" width="15">{{$t('hotel.search')}}</button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </transition>
                  </template>
                  <!-- PROMO -->
                  <template v-else-if="type == 'promo'">
                    <div class="mb-2 pb-1">
                      <div class="row">
                        <div class="col-1 align-self-center">
                          <img src="../../../assets/img/icon/back-arrow.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" v-if="getBeFirstLoad()" @click="changeView('swipe','guest')">
                          <img src="../../../assets/img/icon/close.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" v-else @click="changeView('close','close')">
                        </div>
                        <div class="col-11 align-self-center">
                          <p class="mb-0 body-2-4 mt-1">{{ getMerchant().name }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="pb-2">
                      <PromoCode type="mobile" :data.sync="promo_code" :date.sync="dateRange" @hitSearch="searchClicked"></PromoCode>
                    </div>
                    <template>
                      <div class="position-relative" style="z-index: 1037;">
                        <div class="row no-gutters justify-content-center">
                          <div class="fixed-bottom d-block" style="bottom:0px">
                            <div class="custom-container-fluid px-0">
                              <div class="row justify-content-center no-gutters">
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                                  <div class="container bg-white px-4 py-2 box-shadow-top">
                                    <div class="row slim-grid-row">
                                      <div class="col-12">
                                        <button type="button" class="button-secondary w-100" @click="changeView('close','done')">
                                          <template v-if="hasPromoCode"><img src="../../../assets/img/icon/search-white.png" class="mr-1 position-relative" style="top: -1px;" width="15">{{$t('hotel.search')}}</template>
                                          <template v-else>{{$t('hotel.next')}}</template>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import DateRangePicker from 'vue2-daterange-picker';
	import {mapGetters,mapMutations} from 'vuex';
  import {get} from '@/services/index.js';
	import moment from 'moment';
  import {checkDateCheckInOutExp} from '@/utils/index.js'
  import CalendarRoom from '@/components/hotel/be/CalendarRoom'
  import config from '@/config/index.js'
  import PromoCode from './PromoCode.vue';

	export default{
		components:{
			DateRangePicker,
      CalendarRoom,
      PromoCode
		},
		props:['type','merchant_list'],
		data(){
			return{
        is_load: true,
				min_date: moment().subtract(1,'d').toDate(),
				dateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        search_filter: {
          date: {
            check_in: '',
            check_out: ''
          },
          guest: {},
          promo_code: '',
          price: '',
          sort_by: '',
        },
        date_avlb_filter: [],
        guests:[ 
        	{
        		name: this.$t("hotel.adults.adults"),
        		desc: this.getMerchant().adult_description,
            show: true,
        		qty: 1
        	},
        	{
        		name: this.$t("hotel.children.children"),
        		desc: this.getMerchant().children_description,
            show: true,
        		qty: 0
        	},
        	{
        		name: this.$t("hotel.infants.infants"),
        		desc: this.getMerchant().infant_description,
            show: true,
        		qty: 0
        	}
        ],
        promo_code: '',
        merchant_selected: this.type == 'merchant' ? this.merchant_list.find(x=>x.id == this.getMerchant().id) : {} 
			}
		},
		computed: {
			hasPromoCode(){
				return (this.promo_code || '').trim() != ''
			}
		},
		mounted(){
      this.loadFirstData()
		},
		methods:{
			...mapGetters(['getMerchant','getBeFirstLoad','getBeFilter','getCurrentLanguage']),
      ...mapMutations(['setBeFirstLoad','setBeFilter']),
      loadFirstData(){
        this.is_load = true
        let copied = this.$deepCopy(this.getBeFilter())
        this.dateRange = {
          startDate: copied.date.check_in,
          endDate:copied.date.check_out
        }
        this.guests[0].qty = copied.guest.adult
        this.guests[1].qty = copied.guest.child
        this.guests[2].qty = copied.guest.infant
        this.guests[1].show = this.getMerchant().search_room_is_show_filter_pax_child
        this.guests[2].show = this.getMerchant().search_room_is_show_filter_pax_infant
        this.promo_code = copied.promo_code
        this.cekValidateFilterDate()
        if(this.type == 'date'){
          this.loadRoomAvlbByDate(this.getBeFilter().date.check_in)
        } 

        setTimeout(()=>{
          this.is_load = false
        },300)
        
      },
      formatDate(date){
        return moment(date).format("DD MMM YYYY");
      },
      applyDateFilter(date){
        this.dateRange = date
      },
      changeMonth(monthDate,index){
        this.loadRoomAvlbByDate(monthDate)
      },
      dateAvlb(classes, date) {
        if (!classes.off) {
          let month = moment(date).format("MM")
          let dmy = moment(date).format("YYYY-MM-DD")
          let date_index = this.date_avlb_filter.findIndex(y=>y.date == dmy)
          if(date_index != -1){
            classes.off = this.date_avlb_filter[date_index].availability < 1
          }
        }
        return classes
      },
      checkDateRecrsv(date){
        return new Promise(done=>{
          let today = moment().subtract(1,'d').toDate()
          let params = {
            start_date: date,
            end_date: date
          }
          for (let i = 1; i <= moment(date).endOf("month").format('D'); i++) {
            let my = moment(date).format('YYYY-MM')
            let dmy = moment(`${my}-${i}`,'YYYY-MM-D').toDate()
            if(moment(today).isBefore(dmy)){
              params.start_date = dmy
              done(params)
              break
            }else{
            }
            if(i==moment(date).endOf("month").format('D') && moment(dmy).isBefore(today)){
              let next_month = moment(`${my}-1`,'YYYY-MM-D').add(1,'M').toDate()
              this.checkDateRecrsv(next_month).then(result=>{
                done(result)
              })
            }
          }
        })
      },
      async loadRoomAvlbByDate(date){
        this.checkDateRecrsv(date).then(result=>{
          let param = {
            merchant_id: this.getMerchant().id,
            start_date: moment(result.start_date).format('YYYY-MM-DD'),
            end_date: moment(result.end_date).endOf("month").format('YYYY-MM-DD'),
            use_promotion_combine:true
          }
          get("CORE_HOTEL", "search-availability",
            param
          ).then(response => {
            let res = response.data
            if (res.success) {
              this.date_avlb_filter = res.data
            }
          })
        })
        
      },
      dateReset(){
      	this.dateRange = {
          startDate: new Date(),
          endDate: moment().add(this.$defaultFilterBE('night'),'d').toDate(),
        }
      },
      searchClicked(){
        this.changeView('close','done');
      },
      changeView(type,data=''){
      	if(type == 'close'){
          this.cekValidateFilterDate()
          this.cekValidateFilterDateSame()
      		let params = {
      			date:{
      				check_in: this.dateRange.startDate,
							check_out: this.dateRange.endDate
      			},
      			guest:{
      				adult: this.guests[0].qty,
							child: this.guests[1].qty,
							infant: this.guests[2].qty,
      			},
      			promo_code: this.promo_code
      		}
      		this.setBeFilter(params)
      	}
        if(data == 'done' || type == 'change-merchant'){
          this.$trackRoomSearch()
          if(this.$hasGoogleTag()){
            this.$gtag('event','search', { method: 'Google' })
          }
        }
      	this.$emit(type,data)
      },
      changeQty(type,index){
      	if(type == 'inc'){
      		this.guests[index].qty++
      	}else if(type == 'dec'){
      		if(index == 0){
      			if(this.guests[index].qty > 1){
      				this.guests[index].qty--
      			}
      		}else{
      			if(this.guests[index].qty > 0){
      				this.guests[index].qty--
      			}
      		}
      	}else{
      		for(let i = 0; i < this.guests.length;i++){
      			this.guests[i].qty = (i==0) ? 1 : 0
      		}
      	}
      },
      validateFilterDate(){
        checkDateCheckInOutExp()
        let copied = JSON.parse(JSON.stringify(this.getBeFilter()))
        this.dateRange = {
          startDate: copied.date.check_in,
          endDate:copied.date.check_out
        }
      },
      cekValidateFilterDate(){
        let today = this.$startDate()
        let startDate = this.$startDate(this.dateRange.startDate)
        if (moment(startDate).isBefore(today)) {
          this.dateRange.startDate = new Date()
          if (moment(this.$startDate(this.dateRange.endDate)).isSameOrBefore(this.$startDate(this.dateRange.startDate))) {
            this.dateRange.endDate = moment(this.dateRange.startDate).add(this.$defaultFilterBE('night'), 'd').toDate()
            this.cekValidateFilterDateSame() 
          }else{
            this.cekValidateFilterDateSame()
          }
        }
      },
      cekValidateFilterDateSame(){

        if (moment(this.$startDate(this.dateRange.endDate)).isSameOrBefore(this.$startDate(this.dateRange.startDate))) {
          this.dateRange.endDate = moment(this.dateRange.startDate).add(this.$defaultFilterBE('night'), 'd').toDate()
          let params = {
            date:{
              check_in: this.dateRange.startDate,
              check_out: this.dateRange.endDate
            },
            guest:{
              adult: this.guests[0].qty,
              child: this.guests[1].qty,
              infant: this.guests[2].qty,
            },
            promo_code: this.promo_code
          }
          this.setBeFilter(params)
        }
      },
      selectOtherMerchant(merchant){
        this.merchant_selected= merchant
      }
		},
	}
</script>
<style scoped>
  
  .daterangepicker td.in-range {
    background-color: #79a33a7d!important;
    border-color: transparent;
    color: #000;
    border-radius: 0;
  }

</style>


// WEBPACK FOOTER //
// src/components/hotel/be/BeSearchMobile.vue